import {
  StatusKind,
  MonitoringEntity,
  MonitoringType,
} from 'routes/Dashboard/Monitoring/enums';
import MonitoringFilterFieldNames from '@lib/enums/fieldNames/monitoringFilterFieldNames';
import getFilterFieldNameByMonitoringEntity from 'routes/Dashboard/Monitoring/utils/getFilterFieldNameByMonitoringEntity';
import getLegendFilterName from 'routes/Dashboard/Monitoring/utils/getLegendFilterName';

export const PERFORMANCE_LEGEND_BY_SITE_ANOMALIES = {
  entity: MonitoringEntity.Site,
  kind: MonitoringType.Anomaly,
  items: [
    {
      from: 0,
      to: 0,
      color: 'green',
    },
    {
      from: 1,
      to: 20,
      color: 'yellow',
    },
    {
      from: 21,
      to: 50,
      color: 'blue',
    },
    {
      from: 51,
      to: null,
      color: 'red',
    },
  ],
};

export const PERFORMANCE_LEGEND_BY_SITE_PERFORMANCE = {
  entity: MonitoringEntity.Site,
  kind: MonitoringType.Anomaly,
  items: [
    {
      from: 0,
      to: 10,
      color: 'green',
    },
    {
      from: 11,
      to: 30,
      color: 'yellow',
    },
    {
      from: 31,
      to: 50,
      color: 'orange',
    },
    {
      from: 51,
      to: 100,
      color: 'red',
    },
  ],
};

export const PERFORMANCE_LEGEND_BY_SECTOR_ANOMALIES = {
  entity: MonitoringEntity.Sector,
  kind: MonitoringType.Anomaly,
  items: [
    {
      from: 0,
      to: 0,
      color: 'green',
    },
    {
      from: 1,
      to: 20,
      color: 'yellow',
    },
    {
      from: 21,
      to: 30,
      color: 'orange',
    },
    {
      from: 31,
      to: null,
      color: 'red',
    },
  ],
};

export const PERFORMANCE_LEGEND_BY_SECTOR_PERFORMANCE = {
  entity: MonitoringEntity.Sector,
  kind: MonitoringType.Anomaly,
  items: [
    {
      from: 0,
      to: 10,
      color: 'green',
    },
    {
      from: 11,
      to: 30,
      color: 'yellow',
    },
    {
      from: 31,
      to: 50,
      color: 'orange',
    },
    {
      from: 51,
      to: 100,
      color: 'red',
    },
  ],
};

export const STATIC_COLORS = {
  blue: '#214EEB',
  green: '#00B67A',
  orange: '#FFA51F',
  violet: '#8621EB',
  pink: '#EB21E3',
  yellow: '#FFE500',
};

export const DASHBOARD_MONITORING_FILTER_FORM_EMPTY_VALUES = {
  // Tabs
  [MonitoringFilterFieldNames.Entity]: MonitoringEntity.Site,
  // Filters
  [getFilterFieldNameByMonitoringEntity(
    MonitoringEntity.Site,
    MonitoringFilterFieldNames.FormCategory,
  )]: [],
  [getFilterFieldNameByMonitoringEntity(
    MonitoringEntity.Site,
    MonitoringFilterFieldNames.FormTemplateName,
  )]: [],
  [getFilterFieldNameByMonitoringEntity(
    MonitoringEntity.Site,
    MonitoringFilterFieldNames.Status,
  )]: {
    value: StatusKind.WarningAndAlert,
  },
  [getFilterFieldNameByMonitoringEntity(
    MonitoringEntity.Site,
    MonitoringFilterFieldNames.Period,
  )]: null,
  [getFilterFieldNameByMonitoringEntity(
    MonitoringEntity.Sector,
    MonitoringFilterFieldNames.FormCategory,
  )]: [],
  [getFilterFieldNameByMonitoringEntity(
    MonitoringEntity.Sector,
    MonitoringFilterFieldNames.FormTemplateName,
  )]: [],
  [getFilterFieldNameByMonitoringEntity(
    MonitoringEntity.Sector,
    MonitoringFilterFieldNames.Status,
  )]: {
    value: StatusKind.WarningAndAlert,
  },
  [getFilterFieldNameByMonitoringEntity(
    MonitoringEntity.Sector,
    MonitoringFilterFieldNames.Period,
  )]: null,
  [MonitoringFilterFieldNames.LastUpdate]: null,
  // Ranges
  [MonitoringFilterFieldNames.Sites]: [],
  [MonitoringFilterFieldNames.Sectors]: [],
  // Legends by status for Anomaly
  [getLegendFilterName(
    MonitoringEntity.Site,
    MonitoringType.Anomaly,
    StatusKind.WarningAndAlert,
  )]: PERFORMANCE_LEGEND_BY_SITE_ANOMALIES,
  [getLegendFilterName(
    MonitoringEntity.Site,
    MonitoringType.Anomaly,
    StatusKind.Warning,
  )]: PERFORMANCE_LEGEND_BY_SITE_ANOMALIES,
  [getLegendFilterName(
    MonitoringEntity.Site,
    MonitoringType.Anomaly,
    StatusKind.Alert,
  )]: PERFORMANCE_LEGEND_BY_SITE_ANOMALIES,
  [getLegendFilterName(
    MonitoringEntity.Site,
    MonitoringType.Anomaly,
    StatusKind.DeadlineMissed,
  )]: PERFORMANCE_LEGEND_BY_SITE_ANOMALIES,
  [getLegendFilterName(
    MonitoringEntity.Sector,
    MonitoringType.Anomaly,
    StatusKind.WarningAndAlert,
  )]: PERFORMANCE_LEGEND_BY_SECTOR_ANOMALIES,
  [getLegendFilterName(
    MonitoringEntity.Sector,
    MonitoringType.Anomaly,
    StatusKind.Warning,
  )]: PERFORMANCE_LEGEND_BY_SECTOR_ANOMALIES,
  [getLegendFilterName(
    MonitoringEntity.Sector,
    MonitoringType.Anomaly,
    StatusKind.Alert,
  )]: PERFORMANCE_LEGEND_BY_SECTOR_ANOMALIES,
  [getLegendFilterName(
    MonitoringEntity.Sector,
    MonitoringType.Anomaly,
    StatusKind.DeadlineMissed,
  )]: PERFORMANCE_LEGEND_BY_SECTOR_ANOMALIES,
  [getLegendFilterName(MonitoringEntity.Site, MonitoringType.Performance)]:
    PERFORMANCE_LEGEND_BY_SITE_PERFORMANCE,
  [getLegendFilterName(MonitoringEntity.Sector, MonitoringType.Performance)]:
    PERFORMANCE_LEGEND_BY_SECTOR_PERFORMANCE,
};
